module.exports = "https://www.gc-qa.gnp.com.mx/55035ac255ec74a7898ea4861dae7fba.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/pago/4.png
// module id = 1043
// module chunks = 0 1